import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S35ClinicInfoSection } from '../components/interactive-sections/S35ClinicInfoSection';
import { getPaddingInputs } from "../utils/builderSharedInputs";

Builder.registerComponent(S35ClinicInfoSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S35ClinicInfo,
    friendlyName: 'S35 Clinic Info',
    inputs: [
        ...getPaddingInputs(),
        {
            name: 'mapIcon',
            type: 'file',
            friendlyName: 'Map Pin Icon',
            helperText: 'Map Pin icon',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe8cc0ff7a853473ebecdc56459f7fe11',
        },
        {
            name: 'phoneIcon',
            type: 'file',
            friendlyName: 'Phone Icon',
            helperText: 'Phone icon',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe8cc0ff7a853473ebecdc56459f7fe11',
        },
        {
            name: 'clockIcon',
            type: 'file',
            friendlyName: 'Clock Icon',
            helperText: 'Clock icon',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe8cc0ff7a853473ebecdc56459f7fe11',
        },
    ],
});
